import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { CostCenters } from "../cost-centers/cost-centers.entity";
import { EmployeeDetails } from '../employee-details/employee-details.entity';
import { Projects } from "../projects/projects.entity";
@Entity('attendance')
export class Attendance {
    @PrimaryGeneratedColumn("increment", { name: 'id' })
    Id: number;
    @Column("int", {
        nullable: false,
        name: "year"
    })
    year: number;
    @Column("int", {
        nullable: false,
        name: "month"
    })
    month: number;
    @Column("int", {
        nullable: false,
        name: "day"
    })
    day: number;
    @Column("int", {
        nullable: true,
        name: "emp_id"
    })
    empId: number;
    @Column("int", {
        nullable: true,
        name: "project_id"
    })
    projectId: number;
    @Column("int", {
        nullable: true,
        name: "cost_center_id"
    })
    costCenterId: number;
    @Column("int", {
        nullable: true,
        default:0,
        name: "sub_contractor_id"
    })
    subContractorId: number;
    @Column("datetime", {
        nullable: true,
        name: "atten_date"
    })
    attenDate: string;

    @Column("char", {
        length: 1,
        nullable: true,
        name: "atten_status"
    })
    attenStatus: string;
    @Column("boolean", {
        default:false,
        name: "attendance_submitted"
    })
    attendanceSubmitted: boolean;
    @Column("int", {
        nullable: true,
        name: "atten_created_user"
    })
    attenCreatedUser: Number | null;
    @Column("boolean", {
        default: false,
        name: "atten_approval_status"
    })
    attenApprovalStatus: boolean;
    @Column("int", {
        nullable: true,
        name: "atten_approved_user"
    })
    attenApprovedUser: Number | null;
    @Column("boolean", {
        default:false,
        name: "ot_submitted"
    })
    otSubmitted: boolean;
    @Column("datetime", {
        nullable: true,
        name: "ot_captured_time"
    })
    otCapturedTime: string;
    @Column("float", {
        nullable: true,
        name: "ot_hours"
    })
    otHours: number;
    @Column("int", {
        nullable: true,
        name: "ot_created_user"
    })
    otCreatedUser: number | null;
    @Column("boolean", {
        default: false,
        name: "ot_approval_status"
    })
    otApprovalStatus: boolean;
    @Column("int", {
        nullable: true,
        name: "ot_approved_user"
    })
    otApprovedUser: number | null;
    @Column("varchar",{
        nullable: false,
        length:10,
        default:0,
        name:"daily_pay"
        })
    dailyPay:string;
    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;
    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;
    @Column("int", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: number | null;
    @Column("varchar", {
        length: 60,
        nullable: true,
        name: "location"
    })
    location: string;
    @Column("varchar", {
        length: 60,
        nullable: true,
        name: "latitude"
    })
    latitude: string;
    @Column("varchar", {
        length: 60,
        nullable: true,
        name: "longitude"
    })
    longitude: string;
    @Column("boolean", {
        default: false,
        name: "payment_status"
    })
    paymentStatus: boolean;
    @Column({
        nullable: true,
        name: "payment_date",
        type: "date"
    })
    paymentDate: Date;
    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    // @ManyToOne(type=>EmployeeDetails, employeeDetails=>employeeDetails.attendanceInfo,{nullable:false})
    // @JoinColumn({ name:"emp_id"})
    // empInfo: EmployeeDetails;

    @ManyToOne(type=>EmployeeDetails, employeeDetails=>employeeDetails.attendanceInfo,{  nullable:false, })
    @JoinColumn({ name:"emp_id"})
    empInfo: EmployeeDetails;

    @ManyToOne(type=>CostCenters, costCenters=>costCenters.costCenterId,{  nullable:false, })
    @JoinColumn({ name:"cost_center_id"})
    costCenterInfo: CostCenters;

    @ManyToOne(type=>Projects, projects=>projects.projectId,{  nullable:false, })
    @JoinColumn({ name:"project_id"})
    projectsInfo: Projects;
}
